import React, { useState } from 'react';

const CriteresReussite: React.FC = () => {
  const [activeTab, setActiveTab] = useState('structure');

  const tabs = [
    { id: 'structure', label: 'Structure', icon: '📊' },
    { id: 'notes', label: 'Notes Requises', icon: '📝' },
    { id: 'passage', label: 'Conditions de Passage', icon: '⬆️' },
    { id: 'jury', label: 'Jury & Révisions', icon: '⚖️' },
    { id: 'diplome', label: 'Diplôme', icon: '🎓' }
  ];

  return (
    <section id="criteres-reussite" className="py-16 bg-white dark:bg-gray-900 transition-colors duration-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* En-tête */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Critères de Réussite
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Système d'évaluation et conditions de passage à l'ISTMECH
          </p>
        </div>

        {/* Navigation */}
        <div className="flex flex-wrap justify-center mb-8 bg-gray-100 dark:bg-gray-800 rounded-xl p-2 transition-colors duration-200">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center px-4 py-3 m-1 rounded-lg font-medium transition-all duration-200 ${activeTab === tab.id
                  ? 'bg-green-600 text-white shadow-lg'
                  : 'text-gray-600 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-700 hover:text-green-600 dark:hover:text-green-400'
                }`}
            >
              <span className="mr-2">{tab.icon}</span>
              <span className="hidden sm:inline">{tab.label}</span>
            </button>
          ))}
        </div>

        {/* Contenu */}
        <div className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-8 transition-colors duration-200">
          {/* STRUCTURE */}
          {activeTab === 'structure' && (
            <div className="space-y-8">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Structure de la Formation
                </h3>
              </div>

              {/* 8 semestres */}
              <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-blue-900 dark:text-blue-100 mb-6 text-center">
                  Formation sur 8 Semestres
                </h4>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((sem) => (
                    <div key={sem} className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                      <div className="text-2xl font-bold text-blue-600 dark:text-blue-400 mb-1">S{sem}</div>
                      <div className="text-blue-800 dark:text-blue-200 text-sm">
                        {sem <= 2
                          ? '1ère Année'
                          : sem <= 4
                            ? '2ème Année'
                            : sem <= 6
                              ? '3ème Année'
                              : '4ème Année'}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Sessions d'examens */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500 dark:border-green-400 p-6 rounded-r-lg">
                  <h5 className="text-lg font-bold text-green-900 dark:text-green-100 mb-3">1ère Session</h5>
                  <p className="text-green-800 dark:text-green-200 mb-2">📅 Février</p>
                  <p className="text-green-700 dark:text-green-300 text-sm">Fin du 1er semestre</p>
                </div>

                <div className="bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-500 dark:border-blue-400 p-6 rounded-r-lg">
                  <h5 className="text-lg font-bold text-blue-900 dark:text-blue-100 mb-3">2ème Session</h5>
                  <p className="text-blue-800 dark:text-blue-200 mb-2">📅 Juillet</p>
                  <p className="text-blue-700 dark:text-blue-300 text-sm">Fin du 2ème semestre</p>
                </div>

                <div className="bg-orange-50 dark:bg-orange-900/20 border-l-4 border-orange-500 dark:border-orange-400 p-6 rounded-r-lg">
                  <h5 className="text-lg font-bold text-orange-900 dark:text-orange-100 mb-3">Session Extraordinaire</h5>
                  <p className="text-orange-800 dark:text-orange-200 mb-2">📅 Rattrapage</p>
                  <p className="text-orange-700 dark:text-orange-300 text-sm">Matières non réussies</p>
                </div>
              </div>

              {/* Évaluations */}
              <div className="bg-purple-50 dark:bg-purple-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-purple-900 dark:text-purple-100 mb-4">Types d'Évaluations</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                    <span className="text-2xl mb-2 block">📚</span>
                    <div className="font-semibold text-purple-900 dark:text-purple-100">Théorie</div>
                  </div>
                  <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                    <span className="text-2xl mb-2 block">🔬</span>
                    <div className="font-semibold text-purple-900 dark:text-purple-100">Pratique</div>
                  </div>
                  <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                    <span className="text-2xl mb-2 block">🏥</span>
                    <div className="font-semibold text-purple-900 dark:text-purple-100">Stages</div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* NOTES REQUISES */}
          {activeTab === 'notes' && (
            <div className="space-y-8">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Notes Minimales Requises
                </h3>
              </div>

              {/* Tableau des notes */}
              <div className="bg-white dark:bg-gray-700 rounded-xl p-6 shadow-lg">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-6">
                    <h4 className="text-xl font-bold text-blue-900 dark:text-blue-100 mb-4">Matières Standard</h4>
                    <div className="text-center">
                      <div className="text-4xl font-bold text-blue-600 dark:text-blue-400 mb-2">65%</div>
                      <div className="text-blue-800 dark:text-blue-200">Note minimale requise</div>
                    </div>
                  </div>

                  <div className="bg-green-50 dark:bg-green-900/20 rounded-lg p-6">
                    <h4 className="text-xl font-bold text-green-900 dark:text-green-100 mb-4">Matières Spéciales</h4>
                    <div className="text-center">
                      <div className="text-4xl font-bold text-green-600 dark:text-green-400 mb-2">70%</div>
                      <div className="text-green-800 dark:text-green-200">Note minimale requise</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Exigences spécifiques */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-purple-50 dark:bg-purple-900/20 border-l-4 border-purple-500 dark:border-purple-400 p-6 rounded-r-lg">
                  <h5 className="text-lg font-bold text-purple-900 dark:text-purple-100 mb-3">Examens Pratiques</h5>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-purple-600 dark:text-purple-400 mb-2">70%</div>
                    <div className="text-purple-800 dark:text-purple-200 text-sm">Minimum obligatoire</div>
                  </div>
                </div>

                <div className="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 dark:border-red-400 p-6 rounded-r-lg">
                  <h5 className="text-lg font-bold text-red-900 dark:text-red-100 mb-3">Stages</h5>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-red-600 dark:text-red-400 mb-2">70%</div>
                    <div className="text-red-800 dark:text-red-200 text-sm">Minimum obligatoire</div>
                  </div>
                </div>
              </div>

              {/* Notes d'élimination */}
              <div className="bg-red-100 dark:bg-red-800/30 rounded-xl p-6">
                <h4 className="text-xl font-bold text-red-900 dark:text-red-100 mb-4 text-center">
                  🚫 Notes d'Élimination
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-red-200 dark:bg-red-800/40 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-red-900 dark:text-red-100 mb-2">&lt; 30%</div>
                    <div className="text-red-800 dark:text-red-200 text-sm">Matières à 65% requis</div>
                  </div>
                  <div className="bg-red-200 dark:bg-red-800/40 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-red-900 dark:text-red-100 mb-2">&lt; 40%</div>
                    <div className="text-red-800 dark:text-red-200 text-sm">Matières à 70% requis</div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* CONDITIONS DE PASSAGE */}
          {activeTab === 'passage' && (
            <div className="space-y-8">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Conditions de Passage
                </h3>
              </div>

              {/* Passage normal */}
              <div className="bg-green-50 dark:bg-green-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-green-900 dark:text-green-100 mb-4">✅ Passage Normal</h4>
                <p className="text-green-800 dark:text-green-200 mb-4">
                  Réussir toutes les matières avec les notes minimales requises
                </p>
              </div>

              {/* Passage conditionnel */}
              <div className="bg-yellow-50 dark:bg-yellow-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-yellow-900 dark:text-yellow-100 mb-4">⚠️ Passage Conditionnel</h4>
                <div className="space-y-4">
                  <p className="text-yellow-800 dark:text-yellow-200">
                    Admission possible avec <strong>maximum 2 matières non réussies</strong>
                  </p>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-yellow-100 dark:bg-yellow-800/30 rounded-lg p-4">
                      <h5 className="font-bold text-yellow-900 dark:text-yellow-100 mb-2">Matières à 65%</h5>
                      <p className="text-yellow-800 dark:text-yellow-200 text-sm">Note minimale: <strong>60%</strong></p>
                    </div>
                    <div className="bg-yellow-100 dark:bg-yellow-800/30 rounded-lg p-4">
                      <h5 className="font-bold text-yellow-900 dark:text-yellow-100 mb-2">Matières à 70%</h5>
                      <p className="text-yellow-800 dark:text-yellow-200 text-sm">Note minimale: <strong>65%</strong></p>
                    </div>
                  </div>

                  <div className="bg-yellow-200 dark:bg-yellow-800/40 rounded-lg p-4">
                    <p className="text-yellow-900 dark:text-yellow-100 font-medium text-center">
                      📝 Obligation de représenter les examens non réussis
                    </p>
                  </div>
                </div>
              </div>

              {/* Règles strictes */}
              <div className="bg-red-50 dark:bg-red-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-red-900 dark:text-red-100 mb-4">🚫 Interdictions</h4>
                <ul className="space-y-3 text-red-800 dark:text-red-200">
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <strong>Plus de 2 matières non réussies</strong> = Pas de passage
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <strong>Absence à un examen</strong> = Élimination d'office
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <strong>1ère année</strong> = Aucun redoublement possible
                  </li>
                </ul>
              </div>

              {/* Spécificité 3ème année */}
              <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-blue-900 dark:text-blue-100 mb-4">🎓 Troisième Année</h4>
                <p className="text-blue-800 dark:text-blue-200 mb-4">La note finale prend en compte :</p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="bg-blue-100 dark:bg-blue-800/30 rounded-lg p-3 text-center">
                    <div className="font-semibold text-blue-900 dark:text-blue-100 text-sm">Matières Théoriques</div>
                  </div>
                  <div className="bg-blue-100 dark:bg-blue-800/30 rounded-lg p-3 text-center">
                    <div className="font-semibold text-blue-900 dark:text-blue-100 text-sm">Stages HUJ</div>
                  </div>
                  <div className="bg-blue-100 dark:bg-blue-800/30 rounded-lg p-3 text-center">
                    <div className="font-semibold text-blue-900 dark:text-blue-100 text-sm">Stages Extra Muros</div>
                  </div>
                  <div className="bg-blue-100 dark:bg-blue-800/30 rounded-lg p-3 text-center">
                    <div className="font-semibold text-blue-900 dark:text-blue-100 text-sm">Comportement</div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* JURY & RÉVISIONS */}
          {activeTab === 'jury' && (
            <div className="space-y-8">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Jury d'Examens & Révisions
                </h3>
              </div>

              {/* 3 Jurys */}
              <div className="bg-purple-50 dark:bg-purple-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-purple-900 dark:text-purple-100 mb-6 text-center">
                  3 Jurys d'Examens
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-purple-600 dark:text-purple-400 mb-2">Jury 1</div>
                    <div className="text-purple-800 dark:text-purple-200 text-sm">Première Année</div>
                  </div>
                  <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-purple-600 dark:text-purple-400 mb-2">Jury 2</div>
                    <div className="text-purple-800 dark:text-purple-200 text-sm">Deuxième Année</div>
                  </div>
                  <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-purple-600 dark:text-purple-400 mb-2">Jury 3</div>
                    <div className="text-purple-800 dark:text-purple-200 text-sm">Troisième Année</div>
                  </div>
                </div>
              </div>

              {/* Décisions du jury */}
              <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-blue-900 dark:text-blue-100 mb-4">⚖️ Décisions du Jury</h4>
                <ul className="space-y-3 text-blue-800 dark:text-blue-200">
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    Prises à la <strong>majorité des membres</strong> après délibération
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <strong>Sans appel</strong> pour les cas litigieux
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    Seul le jury peut changer sa décision si l'étudiant a été <strong>lésé</strong>
                  </li>
                </ul>
              </div>

              {/* Révision des copies */}
              <div className="bg-green-50 dark:bg-green-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-green-900 dark:text-green-100 mb-4">📝 Révision des Copies</h4>
                <div className="space-y-4">
                  <div className="bg-green-100 dark:bg-green-800/30 rounded-lg p-4">
                    <h5 className="font-bold text-green-900 dark:text-green-100 mb-2">Procédure</h5>
                    <ul className="text-green-800 dark:text-green-200 space-y-1 text-sm">
                      <li>• Demande par écrit à la Direction</li>
                      <li>• Délai maximum: <strong>48 heures</strong> après proclamation</li>
                      <li>• Maximum <strong>5 matières</strong> par demande</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* DIPLÔME */}
          {activeTab === 'diplome' && (
            <div className="space-y-8">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Obtention du Diplôme
                </h3>
              </div>

              {/* Exigence absolue */}
              <div className="bg-red-50 dark:bg-red-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-red-900 dark:text-red-100 mb-4 text-center">
                  🎓 Exigence Absolue pour le Diplôme
                </h4>
                <div className="bg-red-100 dark:bg-red-800/30 rounded-lg p-6">
                  <p className="text-red-900 dark:text-red-100 font-bold text-center text-lg">
                    Satisfaire à <strong>TOUTES les matières indistinctement</strong> enseignées à l'Institut
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                    <div className="text-center">
                      <span className="text-2xl block mb-2">📚</span>
                      <div className="font-semibold text-red-900 dark:text-red-100">Théorie</div>
                    </div>
                    <div className="text-center">
                      <span className="text-2xl block mb-2">🔬</span>
                      <div className="font-semibold text-red-900 dark:text-red-100">Pratique</div>
                    </div>
                    <div className="text-center">
                      <span className="text-2xl block mb-2">🏥</span>
                      <div className="font-semibold text-red-900 dark:text-red-100">Stages</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Palmarès */}
              <div className="bg-yellow-50 dark:bg-yellow-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-yellow-900 dark:text-yellow-100 mb-4 text-center">
                  🏆 Palmarès Final
                </h4>
                <p className="text-yellow-800 dark:text-yellow-200 text-center">
                  À la fin des études, compilation des résultats des <strong>trois années</strong>
                  et établissement d'un palmarès <strong>par ordre de mérite</strong>
                </p>
              </div>

              {/* Certificats disponibles */}
              <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-blue-900 dark:text-blue-100 mb-4">📜 Certificats Délivrés</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-green-100 dark:bg-green-800/30 rounded-lg p-4">
                    <h5 className="font-bold text-green-900 dark:text-green-100 mb-2">✅ Avec réussite complète</h5>
                    <ul className="text-green-800 dark:text-green-200 text-sm space-y-1">
                      <li>• Diplôme de Technologiste Médical</li>
                      <li>• Certificats de réussite</li>
                    </ul>
                  </div>
                  <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-4">
                    <h5 className="font-bold text-gray-900 dark:text-gray-100 mb-2">⚠️ Sans réussite complète</h5>
                    <ul className="text-gray-800 dark:text-gray-300 text-sm space-y-1">
                      <li>• Certificat d'appartenance à l'Institut uniquement</li>
                      <li>• Aucun diplôme professionnel</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CriteresReussite;
